// Deterministic on-brand colors for contact tags.
const PALETTE = [
  'bg-rose-100 text-rose-700 border-rose-200',
  'bg-sky-100 text-sky-700 border-sky-200',
  'bg-emerald-100 text-emerald-700 border-emerald-200',
  'bg-violet-100 text-violet-700 border-violet-200',
  'bg-amber-100 text-amber-700 border-amber-200',
  'bg-teal-100 text-teal-700 border-teal-200',
  'bg-fuchsia-100 text-fuchsia-700 border-fuchsia-200',
  'bg-indigo-100 text-indigo-700 border-indigo-200',
];

// Fixed colors for the ready-made suggested tags.
const FIXED = {
  lead: 'bg-amber-100 text-amber-700 border-amber-200',
  client: 'bg-emerald-100 text-emerald-700 border-emerald-200',
  supplier: 'bg-sky-100 text-sky-700 border-sky-200',
  employee: 'bg-indigo-100 text-indigo-700 border-indigo-200',
  candidate: 'bg-violet-100 text-violet-700 border-violet-200',
  agent: 'bg-teal-100 text-teal-700 border-teal-200',
  partner: 'bg-fuchsia-100 text-fuchsia-700 border-fuchsia-200',
  investor: 'bg-rose-100 text-rose-700 border-rose-200',
};

export function tagColor(tag) {
  const key = (tag || '').toLowerCase();
  if (FIXED[key]) return FIXED[key];
  let h = 0;
  for (let i = 0; i < key.length; i += 1) h = (h * 31 + key.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length];
}
